/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Matchingdaydate_None_Selected2Inputs */

const en_job_form_matchingdaydate_none_selected2 = /** @type {(inputs: Job_Form_Matchingdaydate_None_Selected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Matching Day selected yet`)
};

const de_job_form_matchingdaydate_none_selected2 = /** @type {(inputs: Job_Form_Matchingdaydate_None_Selected2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Matching Day ausgewählt`)
};

/**
* | output |
* | --- |
* | "No Matching Day selected yet" |
*
* @param {Job_Form_Matchingdaydate_None_Selected2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_matchingdaydate_none_selected2 = /** @type {((inputs?: Job_Form_Matchingdaydate_None_Selected2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Matchingdaydate_None_Selected2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_matchingdaydate_none_selected2(inputs)
	return en_job_form_matchingdaydate_none_selected2(inputs)
});
export { job_form_matchingdaydate_none_selected2 as "job_form_matchingDayDate_none_selected" }